import { AbcTabPanelComponent, GalleryModel } from '@barthauer/abc/ui-components';
import { Item } from 'devextreme/ui/tab_panel';
import { DataFormService } from '../../data-form.service';
import { DataFormSettings } from '../settings.model';
import { UiCreatorBase } from './ui-creator-base';
export class AbcTabsUiCreator extends UiCreatorBase {
  constructor(private service: DataFormService, private settings: DataFormSettings) {
    super(service, settings);
  }

  public async create(dataSource?: Item[] | GalleryModel[]): Promise<HTMLElement> {
    const cpt = this.service.abcContainer.createComponent(this.tabsDirective, AbcTabPanelComponent);

    const componentInstance = cpt.componentRef.instance as AbcTabPanelComponent;
    componentInstance.items = <Item[]>dataSource ?? this.settings.tabsDataSource;
    componentInstance.animationEnabled = true;
    componentInstance.swipeEnabled = true;
    componentInstance.tabsPosition = 'top';
    componentInstance.width = '100%';

    const domElement = cpt.domElement;
    domElement.id = 'tabsInDataForm';
    domElement.style.background = 'unset';

    if (!dataSource) {
      this.settings.abcTabsCptRef = {
        componentRef: cpt?.componentRef,
        domElement: cpt?.domElement,
      };
    }
    return domElement;
  }

  public update(identifier: string): void {
    const tabPanel: AbcTabPanelComponent = this.settings.abcTabsCptRef?.componentRef?.instance as AbcTabPanelComponent;
    if (tabPanel) {
      tabPanel.items.forEach((item: Item, index: number) => {
        const propName = 'is' + identifier + 'Checked';
        const isChecked = this.settings[propName];
        if (item.text === identifier) {
          item.visible = isChecked;
          isChecked ? (tabPanel.selectedIndex = index) : (tabPanel.selectedIndex = index - 1);
        }
      });
    }
  }
}
